import { render, staticRenderFns } from "./MyCoupon.vue?vue&type=template&id=b2833200"
import script from "./MyCoupon.vue?vue&type=script&lang=js"
export * from "./MyCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports